// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import { mtCurrencyDto, profileDto } from "../../../../api/Dtos/profileDto";
// import { useToaster } from "../../../../Toaster/Toaster";
// import { mtCountryDto } from "../../../../api/interfaces/addUser";
// import { Controller, SubmitHandler, useForm } from "react-hook-form";
// import { useLoader } from "../../../../Loader/LoaderContext";
// import { getService, postService } from "../../../../servce/ApisService";
// import { API_ENDPOINTS } from "../../../../api";
// import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
// import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import DynamicTextPop from "../../../Portals/Modals/DynamicTextPop";
// import DynamicTextPopup from "../../../Portals/Modals/dynamicTextPopup";
// import DynamicSuccessPopup from "../../../Portals/Modals/DynamicSuccessPopup";
// function HospitalProfile() {
//   const leadId =localStorage.getItem('leadId');
//   const[isOpen,setOpen] =useState(false);
//   const router=useNavigate();
//   const [isApprove,setIsApprove]=useState(false);
//   const [isDisabled, setIsDisabled] = useState(true);
//      const [formData, setFormData] = useState<profileDto>();
//       const [showConfirmation, setShowConfirmation] = useState(false);
//         const [selectedFiles, setSelectedFiles] = useState<string[]>([]);
//         const [files, setFiles] = useState<(File | null)[]>([]);
//         const [userInfo, setUserInfo] = useState<any>(null);
//         const services = [
//             { id: 1, name: 'IVF Treatment' },
//             { id: 2, name: 'IUI Treatment' },
//             { id: 3, name: 'Surrogacy' },
//             { id: 4, name: 'Egg/Sperm Freezing Treatment' },
//             { id: 5, name: 'Fertility Preservation' },
//             { id: 6, name: 'Fertility Testing' },
//           ];
//           const treatmentMapping = {
//             'IVF Treatment': 'IVF_TREATMENT',
//             'IUI Treatment': 'IUI_TREATMENT',
//             'Surrogacy': 'SURROGACY',
//             'Egg/Sperm Freezing Treatment': 'SPERM_OR_EGG_FREEZING',
//             'Fertility Preservation': 'FERTILITY_PRESERVATION',
//             'Fertility Testing': 'FERTILITY_TESTING',
//           } as const; // This ensures that the keys are treated as string literals

//           // Function to map the treatment name to the backend value
//           const formatTreatmentType = (serviceName: string): string | null => {
//             return treatmentMapping[serviceName as keyof typeof treatmentMapping] || null;
//           };
//           const [expanded, setExpanded] = useState<string | false>(false);
//           const [expanded1, setExpanded1] = useState<string | false>(false);
//           const [events, setEvents] = useState<any[]>([]);
//           const [events1, setEvents1] = useState<any[]>([]);
//          const [defaultCurrencyId, setDefaultCurrencyId] = useState<number | null>(null);
//         const [mtCurrencyData, setMtCurrency] = useState<mtCurrencyDto[]>([]);
//         const { showToast } = useToaster();
//       const [isLoading, setIsLoading] = useState(true);
//       const [mtContryData, setMtCountry] = useState<mtCountryDto[]>([]);
//       const [phoneCode, setPhonecode] = useState({ isoCode: "", code: "" });
//       const [selectedCountry, setSelectedCountry] = useState("");
//       const [submittedData, setSubmittedData] = useState<profileDto | null>(null);
//        const [selectedFile, setSelectedFile] = useState<File | null>(null);
//           const [file, setFile] = useState<string | null>(null);

//           const {
//             register,
//             handleSubmit,
//             control,
//             watch,
//             setValue,
//             reset,
//             setError,
//             clearErrors,
//             trigger,
//             formState: { errors ,isValid},
//           } = useForm<profileDto>({
//             defaultValues: {
//               name: '',
//               email: '',
//               phoneNo: '',
//               phoneisoCode: '',
//               hospitalInfo: '',
//               specialization: '',
//               size: '',
//               street: '',
//               apartment: '',
//               state: '',
//               postalCode: '',
//               mtCountryDto: { id: 0, name: '' },
//               city: '',
//               imageDto: {},
//               serviceOfferedDtos: [{ type: '', cost: '', mtCurrencyDto: { id: 0, name: '' } }],
//               leaderShipTeamDtos: [{ id: 0, name: '', gender: '', designation: '', bio: '', address: '', fileDto: {} }],
//               hospitalCenterReqDtos: [{ id: 0, branchAddress: '', specialization: '', centerSize: '', imageDto: {}, type: '', name: '' }],
//               profileStatus: '',
//             },
//             mode: 'onChange',
//           });
//           useEffect(() => {
//             const isAnyChecked = services.some((_, index) => Boolean(watch(`serviceOfferedDtos.${index}.type`)));

//             // 🔥 Force form validation update to refresh button state
//             trigger();

//             setIsDisabled(!isAnyChecked);
//           }, [watch, trigger]);
//           const watchedServices = watch('serviceOfferedDtos');
//           const { setLoading } = useLoader();
//           useEffect(() => {
//             if (typeof window !== 'undefined') {
//               const storedUserInfo = localStorage.getItem('userInfo');
//               if (storedUserInfo) {
//                  setUserInfo(JSON.parse(storedUserInfo)); // Set userInfo from localStorage
//               }}
//             const initializeData = async () => {
//               setLoading(true);
//               try {
//                 await mtCountryDtoData();
//                 await fetchDetails();
//                 await fetchMtCurrencyData();
//               } catch (error) {
//                 console.error("Error during initialization:", error);
//               } finally {
//                 setLoading(false);
//               }
//             };

//             initializeData();
//           }, []);
//          const fetchMtCurrencyData = async () => {
//              try {
//                const response = await getService(API_ENDPOINTS.mtCurrency);
//                setMtCurrency(response.data);
//                const inrCurrency = response.data.find(
//                  (currency: mtCurrencyDto) => currency.name === 'INR'
//                );
//                if (inrCurrency) {
//                  setDefaultCurrencyId(inrCurrency.id);
//                  services.forEach((_, index) => {
//                    setValue(`serviceOfferedDtos.${index}.mtCurrencyDto.id`, inrCurrency.id);
//                  });
//                }
//              } catch (error) {
//                console.error('Error fetching currency data:', error);
//              }
//            }
//            const handleAddEvent = () => {
//             const newEventId = events.length + 1;
//             setEvents([
//               ...events,
//               {
//                 id : newEventId,
//                 name: `Event ${newEventId}`,
//                 gender: "",
//                 designation: "",
//                 bio: "",
//                 address: "",

//                 fileDto: {
//                   name: "",
//                   base64Str: "",
//                   type: "",
//                   documentUrl: "",
//                 },
//               },
//             ]);
//             setExpanded(`panel${newEventId}`);
//           };
//           const handleAddEvents = () => {
//             const newEventId = events1.length + 1;
//             setEvents1([
//               ...events1,
//               {
//                 id: newEventId,
//                 name: `Event ${newEventId}`,
//                 startDate: "",
//                 endDate: "",
//                 contactPersonName: "",
//                 contactPersonEmail: "",
//                 phoneNo: "",
//                 mtCountryDto: {
//                   id: null,
//                   name: "",
//                   code: "",
//                   isoCode: "",
//                 }, // Default mtCountryDto object
//                 venue: "",
//                 link: "",
//                 type: "",
//                 imageDto: {
//                   name: "",
//                   base64Str: "",
//                   type: "",
//                   documentUrl: "",
//                 },
//               },
//             ]);
//             setExpanded1(`panel${newEventId}`);
//           };
//            const fetchDetails = async () => {
//                 try {
//                   let url:string;
//                   const response = await getService(API_ENDPOINTS.getProfile+"?leadId="+leadId); // Fetch post details using 'id'
//             setSubmittedData(response.data);
//             const res =response.data;
//             setEvents(response.data.leaderShipTeamDtos);
//             setEvents1(response.data.hospitalCenterReqDtos)
//             const countryData = await mtCountryDtoData();
//             setSelectedCountry(response.data?.mtCountryDto?.id);
//             const selectedIsoCode = response.data?.mtCountryDto?.id;
//              const selectedCountry = countryData.find(
//                 (country: any) => country.id === selectedIsoCode
//               );
//               if (selectedCountry) {
//                 setPhonecode({
//                   isoCode: selectedCountry.isoCode,
//                   code: selectedCountry.code,
//                 });
//                 setValue("phoneisoCode", selectedIsoCode);}
//             reset({
//               ...response.data, // Resetting other data from the response
//               mtCountryDto: response.data?.mtCountryDto?.id || "",
//             })
//                   setTimeout(() => {
//                     setLoading(false); // Stop loader after 500ms
//                     setIsLoading(false); // Stop local loading
//                   }, 500);
//                 } catch (error) {
//                   console.error("Error fetching post details:", error);
//                   setTimeout(() => {
//                     setLoading(false); // Stop loader in case of error
//                     setIsLoading(false);
//                   }, 500);
//                 }
//               };

//           const mtCountryDtoData = async () => {
//               setLoading(true);
//               try {
//                 const response = await getService(API_ENDPOINTS.countryData);
//                 console.log(response.data);
//                 setMtCountry(response.data);
//                 return response.data;
//               } catch (error) {
//                 console.error("Error fetching vehicle data:", error);
//               } finally {
//                 setTimeout(() => {
//                   setLoading(false);
//                 }, 500);
//               }
//             };
//             const handleChange =
//         (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
//           setExpanded(isExpanded ? panel : false);
//         };
//         const handleChanges =
//         (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
//           setExpanded1(isExpanded ? panel : false);
//         };
//             const phoneNuberChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//               const selectedIsoCode = e.target.value;
//               console.log("Selected ISO Code:", selectedIsoCode);

//               const selectedCountry = mtContryData.find(
//                 (country: any) => country.isoCode === selectedIsoCode
//               );

//               if (selectedCountry) {
//                 setPhonecode({
//                   isoCode: selectedCountry.isoCode,
//                   code: selectedCountry.code,
//                 });

//                 console.log("Updated Phone Code:", {
//                   isoCode: selectedCountry.isoCode,
//                   code: selectedCountry.code,
//                 });

//                 setValue("phoneisoCode", selectedIsoCode); // Update the selected value for the form
//               }
//             };
//             const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//                 const selectedCountryId = e.target.value;
//                 setSelectedCountry(selectedCountryId);

//                 const selectedCountry = mtContryData.find(
//                   (country: any) => country.id == selectedCountryId
//                 );
//                 if (selectedCountry) {
//                   setPhonecode((prev) => {
//                     const updatedPhoneCode = {
//                       isoCode: selectedCountry.isoCode,
//                       code: selectedCountry.code,
//                     };
//                     return updatedPhoneCode;
//                   });
//                   console.log(phoneCode);
//                 }
//               };
//               const handleFileChanges = (
//                 event: React.ChangeEvent<HTMLInputElement>,
//                 index: number
//               ) => {
//                 const file = event.target.files?.[0];
//                 const allowedTypes = ["image/png", "image/jpeg"];
//                 const maxSizeInMB = 3;

//                 if (file) {
//                   // Validate file type
//                   if (!allowedTypes.includes(file.type)) {
//                     alert("Please select a valid image (PNG or JPG).");
//                     return;
//                   }

//                   // Validate file size
//                   if (file.size > maxSizeInMB * 1024 * 1024) {
//                     alert(`File size should not exceed ${maxSizeInMB} MB.`);
//                     return;
//                   }

//                   // Create a file URL
//                   const fileUrl = URL.createObjectURL(file);

//                   // Update the file array
//                   setFiles((prevFiles) => {
//                     const updatedFiles = [...prevFiles];
//                     updatedFiles[index] = file; // Assign the file at the given index
//                     return updatedFiles;
//                   });

//                   // Update the preview URL array
//                   setSelectedFiles((prevUrls) => {
//                     const updatedUrls = [...prevUrls];
//                     updatedUrls[index] = fileUrl; // Assign the URL at the given index
//                     return updatedUrls;
//                   });
//                 }
//               };
//               const convertFileToBase64 = (file: File): Promise<string> => {
//                 return new Promise((resolve, reject) => {
//                   const reader = new FileReader();
//                   reader.readAsDataURL(file);
//                   reader.onload = () => resolve(reader.result as string);
//                   reader.onerror = (error) => reject(error);
//                 });
//               };
//                 const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
//                   if (e.target.files && e.target.files[0]) {
//                     const selectedFile = e.target.files[0];
//                     setSelectedFile(selectedFile);
//                     // setValue('imageDto',selectedFile)
//                     // Convert the file to a Base64 string
//                     const preview = await convertToBase64(selectedFile);
//                     setFile(preview);
//                   }
//                 };
//                 const convertToBase64 = (file: File): Promise<string> => {
//                   return new Promise((resolve, reject) => {
//                     const reader = new FileReader();
//                     reader.readAsDataURL(file);
//                     reader.onload = () => resolve(reader.result as string);
//                     reader.onerror = (error) => reject(error);
//                   });
//                 };
//                 const onFormSubmit:SubmitHandler<profileDto> = async (data) => {
//                   setFormData(data);
//                   const isAtLeastOneSelected = data.serviceOfferedDtos.some(
//                     (service) => Boolean(service.type) // Ensures it's a truthy string
//                   );

//                   if (!isAtLeastOneSelected) {
//                     setError("serviceOfferedDtos", {
//                       type: "manual",
//                       message: "At least one service must be selected.",
//                     });
//                   } else {
//                     clearErrors("serviceOfferedDtos");
//                     console.log(data);
//                   }
//                   setShowConfirmation(true);
//                       console.log(data);

//                     }
//                     const closePopup=()=>{
//                       setOpen(false);
//                       router('/vendorDashboard/activateDashbord/HospitalViewProfile/')
//                     }
//                     const handleClosePopup = () => setShowConfirmation(false);
//                     const saveData =async ()=>{
//                       setLoading(true);
//                       try {
//                         const filteredServices = watchedServices
//           .filter((service) => service.type && service.cost && service.mtCurrencyDto.id) // Only valid services
//           .map((service, index) => ({
//             ...service,
//             type: formatTreatmentType(services[index].name), // Map the service name
//             mtCurrencyDto: {
//               id: parseInt(service.mtCurrencyDto.id as unknown as string, 10), // Ensure that the id is parsed as a number
//             },
//           }));
//           const updatedLeaderShipTeamDtos = await Promise.all(
//             (formData?.leaderShipTeamDtos ?? []).map(async (team, index) => {
//               if (files[index]) {
//                 const base64Str = await convertFileToBase64(files[index] as File);
//                 const name = (files[index] as File).name;
//                 const type = (files[index] as File).type;

//                 return {
//                   ...team,
//                   fileDto: {
//                     base64Str: base64Str,
//                     name,
//                     type,
//                   },
//                 };
//               }
//               return team; // Return unchanged object if no file is uploaded
//             })
//           );
//                           let payload={
//                             leadId:leadId,

//                             // ...submittedData,
//                             name:formData?.name,
//                             email:formData?.email,
//                             phoneNo:formData?.phoneNo,
//                             hospitalInfo:formData?.hospitalInfo,
//                             specialization:formData?.specialization,
//                             size:formData?.size,
//                             imageDto:{
//                               name: selectedFile?.name,
//                               type: selectedFile?.type,
//                               base64Str: file,
//                             },
//                             street:formData?.street,
//                             apartment:formData?.apartment,
//                             state:formData?.state,
//                             postalCode:formData?.postalCode,
//                              mtCountryDto: formData?.mtCountryDto ? {
//                                           id: parseInt(formData?.mtCountryDto as unknown as string, 10),
//                                         } : null,
//                                         city:formData?.city,
//                                         serviceOfferedDtos: filteredServices,
//                                         leaderShipTeamDtos: updatedLeaderShipTeamDtos,
//                                         hospitalCenterReqDtos: formData?.hospitalCenterReqDtos.map((center, index) => ({
//                                             ...center,
//                                             id: submittedData?.hospitalCenterReqDtos[index]?.id || null, // Ensure the `id` field is included
//                                           })),

//                           }
//                           if (isApprove) {
//                             (payload as any).profilingStatus = 'PUBLISHED';
//                           }
//                             const response = await postService(API_ENDPOINTS.saveProfile,payload);
//                             if(response){
//                               setSelectedCountry("");
//                               setShowConfirmation(false);
//                               setOpen(true)

//                               showToast('Profile has been updated successfully.','success','')
//                             }
//                       } catch (error: any) {
//                           // setApiError(error.response?.data?.message);
//                           console.error('Login error:', error);
//                           if(error.response?.data?.message === 'Invalid Otp. Please try again.'){

//                           }
//                       }
//                       finally {
//                           setLoading(false);
//                       }
//                     }
//                     const back=()=>{
//                       router('/vendorDashboard/activateDashbord/HospitalViewProfile')
//                     }
//                     const draft=()=>{
//                       setIsApprove(false)
//                     }
//                     const approve=()=>{
//                       setIsApprove(true);
//                     }
//   return (
//     <div className='mb-5 p-6 px-8'>
//         <h3 className='text-gray-900 font-bold text-3xl mb-5 mt-2 flex items-center'> <span><img src='/images/back.svg' className="mr-2 cursor-pointer" onClick={back} /></span>
//         Hospital Details</h3>
//         <form onSubmit={handleSubmit(onFormSubmit)}>
//         <div className=' rounded-lg mt-5'>
//             <div className='bg-white p-8'>
//        <div className='w-[80%]'>
//        <h3 className='text-gray-900 font-bold text-xl'> Basic details</h3>
//        <div className='relative'>
//         <div className=''>
//        <div className=''>
//        <div className='flex items-center py-3'>
//        <img src={
//                           file
//                             ? (file as string)
//                             : selectedFile
//                             ? URL.createObjectURL(selectedFile)
//                             : submittedData?.imageDto?.documentUrl || '/images/userImg.svg'
//                         }
//                         alt="Preview" className='w-[80px] h-[80px] mr-3 rounded-full'  />
//        <div>
//               <p className="font-semibold text-gray-900 text-base font-sans mb-0">
//               Upload Hospital Photo
//               </p>
//               <p className="text-sm font-normal text-gray-500 mt-1 font-sans mb-3">
//                 Photo should be atleast in 150px X 150px
//               </p>
//               <label className=' mt-2 px-4 border border-[#D1D5DB] text-[#374151] font-medium text-sm rounded-md p-2 cursor-pointer'>
//             Upload new photo
//             <input
//               type="file"
//               accept="image/*"
//               onChange={handleFileChange}
//               className="hidden"
//             />
//           </label>
//             </div>
//        </div>
//        <div className="grid grid-cols-1 gap-4 mt-2">

//       <div className="form-group">
//                 <label
//                   htmlFor="username"
//                   className="block text-[#374151] font-semibold text-sm font-sans"
//                 >
//                 Hospital Name
//                 </label>
//                 <div className="input-group mb-3 mt-2">
//                    <input
//                     {...register("name", {
//                       required: 'Name is required',
//                     })}
//                     type="text"
//                     placeholder="Enter Hospital Name"

//                     className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
//                   />
//                   {errors.name && (
//                     <p className="text-primary-color text-sm mt-1">{errors.name.message}</p>
//                   )}
//                 </div>
//               </div>
//       </div>
//        <div className="grid grid-cols-2 gap-7 mb-2 mt-2">

//       <div className="form-group">
//                 <label
//                   htmlFor="username"
//                   className="block text-[#374151] font-semibold text-sm font-sans"
//                 >
//                   Email
//                 </label>
//                 <div className="input-group mb-3 mt-2">
//                    <input
//                     {...register("email", {
//                       required: 'Email is required',
//                     })}
//                     disabled
//                     type="email"
//                     placeholder="Enter your Email"

//                     className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
//                   />
//                   {errors.email && (
//                     <p className="text-primary-color text-sm mt-1">{errors.email.message}</p>
//                   )}
//                 </div>
//               </div>
//               <div className="form-group">
//                 <label
//                   htmlFor="username"
//                   className="block text-[#374151] font-semibold text-sm font-sans"
//                 >
//                   Phone Number
//                 </label>
//                 <div className=" form-group mb-4 sm:mb-0">
//                   <div className="flex border border-gray-300 rounded mt-1 form-controls">
//                     <select
//                       value={phoneCode.isoCode || ""}
//                       {...register("phoneisoCode",

//                       )}

//                       onChange={(e) => phoneNuberChange(e)}
//                       className="border-none bg-white pl-3 py-2 text-sm font-semibold text-gray-700 focus:outline-none"
//                     >
//                       {mtContryData.map((item: any) => (
//                         <option key={item.id} value={item.isoCode || ""}>
//                           {item.isoCode}
//                         </option>
//                       ))}
//                     </select>
//                     <input
//                       type="text"
//                       placeholder="Enter your phone number"
//                       {...register("phoneNo",
//                         {
//                           required: 'Phone Number is required',
//                         }
//                       )}
//                       className="w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none"
//                     />
//                   </div>

//                   {errors.phoneNo && (
//                     <p className="text-primary-color text-sm mt-1">
//                       {errors.phoneNo.message}
//                     </p>
//                   )}
//                 </div>
//               </div>

//       </div>
//       <div className="grid grid-cols-1 gap-4 mt-2">

//       <div className="form-group">
//                 <label
//                   htmlFor="username"
//                   className="block text-[#374151] font-semibold text-sm font-sans"
//                 >
//                 Hospital Info
//                 </label>
//                 <div className="input-group mb-3 mt-2">
//                 <textarea
//                  rows={4}
//                     placeholder="Enter Hospital Info"
//                     {...register("hospitalInfo",{
//                       required:'Hospital Info is required',
//                       maxLength: {
//                         value: 1500,
//                         message: "Hospital information cannot exceed 1500 characters. Please shorten your text.",
//                       },

//                     })}

//                     className="w-full border font-normal font-Inter text-sm text-[#6B7280] p-2 rounded-md"
//                   />
//                   {errors.hospitalInfo && (
//                     <p className="text-primary-color text-sm mt-1">{errors.hospitalInfo.message}</p>
//                   )}
//                 </div>
//               </div>

//       </div>
//       <div className="grid grid-cols-2 gap-5 mb-8">

//       <div className="form-group">
//                 <label
//                   htmlFor="username"
//                   className="block text-[#374151] font-semibold text-sm font-sans"
//                 >
//                   Specialization
//                 </label>
//                 <div className="input-group mb-3 mt-2">
//                    <input
//                     {...register("specialization", {
//                       required: 'specialization is required',
//                     })}
//                     type="text"
//                     placeholder="Enter Specialization"

//                     className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
//                   />
//                   {errors.specialization && (
//                     <p className="text-primary-color text-sm mt-1">{errors.specialization.message}</p>
//                   )}
//                 </div>
//               </div>
//               <div className="form-group">
//                 <label
//                   htmlFor="username"
//                   className="block text-[#374151] font-semibold text-sm font-sans"
//                 >
//                   Hospital Size
//                 </label>
//                 <div className=" mb-3 mt-2">
//                 <select

//                                       {...register(
//                                         `size`,
//                                         {
//                                        required:'size is required'
//                                         }
//                                       )}
//                                       className={`form-control p-2 rounded mt-1 w-full`}
//                                     >
//                                       <option value="">
//                                         Select Center size
//                                       </option>
//                                       <option value="SMALL">Small</option>
//                                       <option value="MEDIUM">Medium</option>
//                                       <option value="LARGE">Large</option>
//                                     </select>
//                                     {errors.size && (
//                     <p className="text-primary-color text-sm mt-1">{errors.size.message}</p>
//                   )}
//                 </div>

//               </div>
//       </div>
//       <p className="border-b-2 border-gray-200"></p>
//       <div className='mt-8'>
//         <h2 className='text-gray-900 font-bold text-[20px]'>Address</h2>
//         <div className="grid grid-cols-1 gap-4 mt-2">

//       <div className="form-group">
//                 <label
//                   htmlFor="username"
//                   className="block text-[#374151] font-semibold text-sm font-Inter"
//                 >
//                 Street Address
//                 </label>
//                 <div className="input-group mb-3 mt-2">
//                    <input
//                     {...register("street", {
//                       required: ' Street Address  is required',
//                     })}
//                     type="text"
//                     placeholder="eg. Street 7"

//                     className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
//                   />
//                   {errors.street && (
//                     <p className="text-primary-color text-sm mt-1">{errors.street.message}</p>
//                   )}
//                 </div>
//               </div>
//       </div>
//       <div className="grid grid-cols-1 gap-4 mt-2">

//       <div className="form-group">
//                 <label
//                   htmlFor="username"
//                   className="block text-[#374151] font-semibold text-sm"
//                 >
//                 Apartment , Suite etc
//                 </label>
//                 <div className="input-group mb-3 mt-2">
//                    <input
//                     {...register("apartment", {
//                       required: 'Apartment is required',
//                     })}
//                     type="text"
//                     placeholder="Enter Apartment Name"

//                     className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
//                   />
//                   {errors.apartment && (
//                     <p className="text-primary-color text-sm mt-1">{errors.apartment.message}</p>
//                   )}
//                 </div>
//               </div>

//       </div>
//       <div className="grid grid-cols-2 gap-5 mt-2">

//       <div className="form-group">
//                 <label
//                   htmlFor="username"
//                   className="block text-[#374151] font-semibold text-sm"
//                 >
//                   Country
//                 </label>
//                 <div className="input-group mb-3 mt-2">
//                 <select
//                     value={selectedCountry || ""}
//                     {...register("mtCountryDto",
//                       {
//                         required: 'Country is required',
//                       }
//                     )}
//                     onChange={(e) => handleCountryChange(e)}
//                     className={`border p-2 rounded-md mt-1 w-full`}
//                   >
//                     <option value="">Select country</option>
//                     {mtContryData.map((item: any) => (
//                       <option
//                         key={item.id}
//                         value={item.id !== null ? item.id : ""}
//                       >
//                         {item.name}
//                       </option>
//                     ))}
//                   </select>
//                   {errors.mtCountryDto && (
//                     <p className="text-primary-color text-sm mt-1">{errors.mtCountryDto.message}</p>
//                   )}
//                 </div>
//               </div>
//               <div className="form-group">
//                 <label
//                   htmlFor="username"
//                   className="block text-[#374151] font-semibold text-sm"
//                 >
//                   State
//                 </label>
//                 <div className="input-group mb-3 mt-2">
//                 <input
//                     {...register("state", {
//                       required: 'State is required',
//                     })}
//                     type="text"
//                     placeholder="Enter state"

//                     className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
//                   />
//                   {errors.state && (
//                     <p className="text-primary-color text-sm mt-1">{errors.state.message}</p>
//                   )}
//                 </div>
//               </div>

//       </div>
//       <div className="grid grid-cols-2 gap-5 mt-2">

//       <div className="form-group">
//                 <label
//                   htmlFor="username"
//                   className="block text-[#374151] font-semibold text-sm"
//                 >
//                   City
//                 </label>
//                 <div className="input-group mb-3 mt-2">
//                    <input
//                     {...register("city", {
//                      required:'City is required'
//                     })}
//                     type="text"
//                     placeholder="Enter City Name"

//                     className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
//                   />
//                   {errors.city && (
//                     <p className="text-primary-color text-sm mt-1">{errors.city.message}</p>
//                   )}
//                 </div>
//               </div>
//               <div className="form-group">
//                 <label
//                   htmlFor="username"
//                   className="block text-[#374151] font-semibold text-sm"
//                 >
//                   Postal Code
//                 </label>
//                 <div className="input-group mb-3 mt-2">
//                    <input
//                     {...register("postalCode", {
//                       required:'Postal Code is required'
//                     })}
//                     type="text"
//                     placeholder="Enter Postal Code"

//                     className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
//                   />
//                   {errors.postalCode && (
//                     <p className="text-primary-color text-sm mt-1">{errors.postalCode.message}</p>
//                   )}
//                 </div>
//               </div>
//                  {/* Fixed Navigation Buttons */}

//       </div>

//       </div>

//     </div>

//         </div>

//         </div>
//        </div>
//         </div>
//         <div className='bg-white p-8 mt-7'>
//           <div className='w-[80%]'>
//           <p className="text-gray-900 font-bold text-[20px] pb-5">Services Offered <span className="text-gray-900 font-normal text-sm ml-2">
//           (Required)
//         </span></p>
//       <div className="grid grid-cols-2 gap-6">
//       {services.map((service, index) => {
//   const isChecked = Boolean(watch(`serviceOfferedDtos.${index}.type`)); // ✅ Ensure boolean value

//   return (
//     <div
//       key={service.id}
//       className="border border-gray-200 rounded-lg p-6 flex flex-col items-start"
//     >
//       {/* Checkbox and Service Name */}
//       <label className="flex items-center mb-5 font-bold text-base font-sans text-gray-900">
//         <input
//           type="checkbox"
//           {...register(`serviceOfferedDtos.${index}.type`)}
//           value="true" // ✅ Ensure string value to avoid mismatch
//           className="mr-4 w-[16px] h-[16px] form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B]"
//         />
//         {service.name}
//       </label>

//       {/* Cost and Currency Fields */}
//       <p className="font-semibold font-Inter text-sm text-gray-700 pb-2">
//         Approximate Cost
//       </p>
//       <div className="w-full flex space-x-2">
//         {/* Currency Field */}
//         <Controller
//           control={control}
//           name={`serviceOfferedDtos.${index}.mtCurrencyDto.id`}
//           rules={{
//             // required: isChecked ? "Currency selection is required." : false,
//           }}
//           render={({ field }) => (
//             <select
//               {...field}
//               value={field.value ?? ""} // ✅ Convert null to empty string
//               disabled={!isChecked}
//               className={`bg-white py-2 text-sm font-semibold text-gray-700 focus:outline-none ${
//                 !isChecked ? "bg-gray-200 cursor-not-allowed" : ""
//               }`}
//             >
//               <option value="">Select</option>
//               {mtCurrencyData.map((item) => (
//                 <option key={item.id} value={item.id ?? ""}>
//                   {item.name}
//                 </option>
//               ))}
//             </select>
//           )}
//         />

//         {errors.serviceOfferedDtos?.[index]?.mtCurrencyDto?.id && (
//           <p className="text-primary-color text-sm">
//             {errors.serviceOfferedDtos[index].mtCurrencyDto.id?.message}
//           </p>
//         )}

//         {/* Cost Field */}
//         <div>
//           <input
//             type="number"
//             {...register(`serviceOfferedDtos.${index}.cost`, {
//               // required: isChecked ? "Cost is required." : false, // ✅ Dynamic validation
//               valueAsNumber: true,
//               setValueAs: (value) => (value === "" ? 0 : value), // ✅ Prevent NaN values
//             })}
//             disabled={!isChecked}
//             placeholder="Enter Approximate Cost"
//             className={`flex-grow border border-gray-300 rounded p-2 font-normal text-base ${
//               !isChecked ? "bg-gray-50 cursor-not-allowed" : ""
//             }`}
//           />
//           {errors.serviceOfferedDtos?.[index]?.cost && (
//             <p className="text-primary-color text-sm">
//               {errors.serviceOfferedDtos[index].cost?.message}
//             </p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// })}

//       </div>
//           </div>
//         </div>
//         <div className='bg-white p-8 mt-7'>
//         <div className=" rounded-lg w-[80%]">
//       <p className="text-gray-900 font-bold text-[20px] font-Inter">
//          Leadership Team
//          {/* <span className='text-gray-900 font-normal text-base'>(Optional)</span> */}
//         <span className="text-gray-900 font-normal text-base ml-2">
//           (Optional)
//         </span>
//       </p>
//       {/* <form onSubmit={handleSubmit(onFormSubmit)}> */}
//       <div className="form-group mb-10 mt-5">
//         {events.map((event: any, index: number) => (
//           <div className="mt-4">
//             <div className="mb-3 bg-gray-100" key={event.id}>
//               <Accordion
//                 key={event?.id}
//                 expanded={expanded === `panel${event?.id}`}
//                 onChange={handleChange(`panel${event?.id}`)}
//                 className="accordion-root"
//                 style={{ boxShadow: "none" }}
//               >
//                 <AccordionSummary
//                   expandIcon={<ExpandMoreIcon />}
//                   aria-controls={`panel${event?.id}-content`}
//                   id={`panel${event?.id}-header`}
//                   className="accordion-summary text-lg font-semibold"
//                   style={{ backgroundColor: "#f3f4f6" }}
//                 >
//                   <Typography
//                     className="text-lg font-semibold"
//                     style={{ fontWeight: "600", fontSize: "18px" }}
//                   >
//                      {submittedData?.leaderShipTeamDtos?.[index]?.name?.trim()
//         ? submittedData?.leaderShipTeamDtos[index].name
//         : `User ${index + 1}`}
//                     {/* User {index +1} */}
//                   </Typography>
//                 </AccordionSummary>
//                 <AccordionDetails className="accordion-details bg-gray-100">
//                   <Typography component={"div"}>
//                     {/* Form details go here */}

//        <div className='flex items-center py-3'>
//        <img src={
//                         files[index] &&
//                         files[index] instanceof Blob
//                           ? URL.createObjectURL(
//                               files[index] as Blob
//                             ) // Type assertion here
//                           : submittedData?.leaderShipTeamDtos[
//                               index
//                             ]?.fileDto?.documentUrl || '/images/userImg.svg'
//                       }
//                         alt="Preview" className='w-[80px] h-[80px] mr-3 rounded-full'  />
//        <div>
//               <p className="font-semibold text-gray-900 text-base font-sans">
//               Upload Hospital Photo
//               </p>
//               <p className="text-sm font-normal text-gray-500 mt-2 font-sans mb-3">
//                 Photo should be atleast in 150px X 150px
//               </p>

//               <label className=' mt-2 px-4 border border-[#D1D5DB] text-[#374151] font-medium text-sm rounded-md p-2 cursor-pointer'>
//             Upload new photo
//             <input
//               type="file"
//               accept="image/*"
//               onChange={(e) =>
//                 handleFileChanges(e, index)
//               }
//               className="hidden"
//             />
//           </label>
//             </div>
//        </div>
//                     <div className="form-group mb-4 ">
//                       <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm font-Inter">
//                         Name
//                       </label>
//                       <div className="relative">
//                       <input
//                     type="text"
//                     placeholder="Enter Name"
//                     {...register(`leaderShipTeamDtos.${index}.name`, { required: "Name is required" })}
//                     className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
//                   />
//                   {errors?.leaderShipTeamDtos?.[index]?.name && <p className="text-primary-color text-sm">{errors?.leaderShipTeamDtos?.[index]?.name?.message}</p>}
//                       </div>
//                     </div>

//                     <div className="grid grid-cols-2 gap-20">
//                       <div className=" form-group mb-4 ">
//                         <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
//                           Gender
//                         </label>
//                         <div className="relative">
//                         <select
//                       {...register(`leaderShipTeamDtos.${index}.gender`)}
//                       className="form-control border mt-1 p-2 rounded w-full font-normal font-Inter text-sm text-[#111827]"
//                     >
//                       <option value="">Select Gender</option>
//                     <option value="MALE">Male</option>
//                     <option value="FEMALE">Female </option>
//                     <option value="OTHER">Others</option>
//                     </select>
//                         </div>
//                       </div>

//                       <div className="form-group mb-4 ">
//                         <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
//                           Designation
//                         </label>
//                         <div className="relative">
//                           <input
//                             type="text"
//                             placeholder="Enter Designation"
//                             {...register(`leaderShipTeamDtos.${index}.designation`)}
//                              className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"

//                           />

//                         </div>
//                       </div>
//                     </div>
//                     <div className="form-group mb-4 ">
//                       <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
//                         Bio
//                       </label>
//                       <div className="relative">
//                         <textarea
//                          rows={4}
//                           placeholder="Enter Bio"
//                           {...register(`leaderShipTeamDtos.${index}.bio`, {
//                             maxLength: {
//                                 value: 500,
//                                 message: "Bio must be at most 500 characters",
//                             },})}
//                           className="w-full border p-2 rounded-md"
//                         />
//                         {errors?.leaderShipTeamDtos?.[index]?.bio && (
//   <p className="text-primary-color text-sm mt-1">{errors?.leaderShipTeamDtos[index]?.bio?.message}</p>
// )}
//                       </div>
//                     </div>
//                     <div className="form-group mb-4 ">
//                       <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
//                       Address
//                       </label>
//                       <div className="relative">
//                         <textarea
//                          rows={4}
//                           placeholder="Enter Address"
//                           {...register(`leaderShipTeamDtos.${index}.address`)}
//                           className="w-full border p-2 rounded-md"
//                         />
//                       </div>
//                     </div>
//                   </Typography>
//                 </AccordionDetails>
//               </Accordion>
//             </div>
//           </div>
//         ))}
//         <div
//           onClick={handleAddEvent}
//           className="mt-4 p-2 w-[11.5rem] h-10 cursor-pointer bg-[#FFFFFF] text-gray-700 rounded border border-gray-300"
//         >
//           {events.length === 0 ? "+ Add User Details" : "+ Add another user"}
//         </div>
//         {/* )} */}
//       </div>

//       {/* </form> */}
//     </div>

//         </div>
//         <div className='bg-white p-8 mt-7'>
//         <div className='w-[80%]'>
//         <p className='text-gray-900 font-bold text-[20px]'>Add center details
//         <span className="text-gray-900 font-normal text-base ml-2">
//           (Optional)
//         </span>
//         </p>
//          {/* <form onSubmit={handleSubmit(onFormSubmit)}> */}
//          <div className="form-group mb-10 mt-5">

//   {events1.map((event: any, index: number) => (
//     <div className="mt-4">
//       {/* <> */}

//       <div className="mb-3 bg-gray-100" key={event.id}>
//         <Accordion
//           key={event?.id}
//           expanded={expanded1 === `panel${event?.id}`}
//           onChange={handleChanges(`panel${event?.id}`)}
//           className="accordion-root"
//           style={{ boxShadow: "none" }}
//         >
//           <AccordionSummary
//             expandIcon={<ExpandMoreIcon />}
//             aria-controls={`panel${event?.id}-content`}
//             id={`panel${event?.id}-header`}
//             className="accordion-summary text-lg font-semibold"
//             style={{ backgroundColor: "#f3f4f6" }}
//           >
//             <Typography
//               className="text-lg font-semibold"
//               style={{ fontWeight: "600", fontSize: "18px" }}
//             >
//  {submittedData?.hospitalCenterReqDtos?.[index]?.name?.trim()
//         ? submittedData.hospitalCenterReqDtos[index].name
//         : `Center ${index + 1}`}
//               {/* Center {index +1} */}
//             </Typography>
//           </AccordionSummary>
//           <AccordionDetails className="accordion-details bg-gray-100">
//             <Typography component={"div"}>
//               {/* Form details go here */}
//               <div className="form-group mb-4 ">
//                 <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
//                 Center Name
//                   {/* <span className="font-[400]"> (Required)</span> */}
//                 </label>
//                 <div className="relative">
//                   <input
//                     type="text"
//                     placeholder="Enter Center Name "
//                     {...register(
//                       `hospitalCenterReqDtos.${index}.name`
//                     )}
//                    className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"

//                   />

//                 </div>
//               </div>

//               <div className="grid grid-cols-2 gap-16">
//                 <div className=" form-group mb-4 ">
//                 <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
//                 Specialization

//                 </label>
//                 <div className="relative">
//                   <input
//                     type="text"
//                     placeholder="Enter Specialization "
//                     {...register(
//                       `hospitalCenterReqDtos.${index}.specialization`
//                     )}
//                    className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"

//                   />

//                 </div>

//                   {/* {errors?.eventReqDtos?.[index]?.startDate && <p className="text-primary-color text-sm mt-1">{errors?.eventReqDtos?.[index]?.startDate}</p>} */}
//                 </div>

//                 <div className="form-group mb-4 ">
//                 <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
//                 Center Size
//                 </label>
//                 <div className="relative">
//                 <div className="relative">
//                 <select  className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
//                   //  value={submittedData?.centerRespDtos?.[index]?.centerSize ?? 'SMALL'}
//                   // value={
//                   //   userId
//                   //     ? submittedData?.centerRespDtos[index]
//                   //         ?.centerSize
//                   //     : submittedData?.centerRespDtos[index]
//                   //         ?.centerSize
//                   // }
//                   {...register(
//                     `hospitalCenterReqDtos.${index}.centerSize`,
//                     // {
//                     //   onChange: (e) =>
//                     //     handleSelectChange(e, index), // Custom change handler
//                     // }
//                   )}

//                 >
//                   <option value="">
//                     Select Center size
//                   </option>
//                   <option value="SMALL">Small</option>
//                   <option value="MEDIUM">Medium</option>
//                   <option value="LARGE">Large</option>
//                 </select>
//               </div>

//                 </div>
//                 </div>
//               </div>

//               <div className="form-group mb-4 ">
//                 <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
//                 Address
//                 </label>
//                 <div className="relative">
//                 <textarea
//                  rows={4}
//   placeholder="Enter Address"
//   {...register(
//     `hospitalCenterReqDtos.${index}.branchAddress`
//   )}
//   className="w-full border p-2 rounded-md"
// />
//                 </div>
//               </div>

//             </Typography>
//           </AccordionDetails>
//         </Accordion>
//       </div>

//       {/* </> */}
//     </div>
//   ))}

//     <div
//       onClick={handleAddEvents}
//       className="mt-4 p-2 w-[11.5rem] h-10 cursor-pointer bg-[#FFFFFF] text-gray-700 rounded border border-gray-300"
//     >
//       {events1.length === 0 ? "+ Add Center Details" : "+ Add another centre"}

// </div>
//         </div>
//         </div>
//         </div>
//         </div>
//         <div className="px-4 flex justify-end  p-4 items-center  bg-white"
//               style={{
//                 boxShadow: "0px -16px 50px 0px #0000000D",
//               }}>
//                  <div>
//                   {
//                     (userInfo?.roles === 'PUBLISHER' && submittedData?.profilingStatus ==='SEND_FOR_APPROVAL') &&

//                  <button
//             type="submit"
//             className="border border-gray-300 px-4 py-2 rounded-md text-sm text-gray-700 mr-2"
//             onClick={draft}
//           >
//        Save as draft
//           </button>
// }
//                  </div>
//         <div>
//        {(userInfo?.roles === 'PUBLISHER' && submittedData?.profilingStatus ==='SEND_FOR_APPROVAL') &&
//           <button
//             type="submit"
//             className="px-7 py-2 gradient-background font-Inter text-white rounded font-bold text-base"
//             onClick={approve}
//             disabled={!isValid || isDisabled}
//           >
//           Approve & Publish profile
//           </button>}
//         </div>
//       </div>
//         </form>
//         {showConfirmation &&
//   <DynamicTextPopup onClose={handleClosePopup} title={isApprove ? 'Confirm Approval & Publish ' :'Confirm Save as draft'}   body={isApprove ? 'Are you sure you want to approve and publish this profile? Once published, the profile will be visible to the public. ' : ' Your hospital profile details will be saved as a draft. You can edit and submit for approval later.'} confirmButtonName={isApprove ? 'Approve & Publish' :'Yes, Save as Draft'} closeButtonName='Cancel'
//   onConfirm={saveData} />
// }
// {isOpen &&
//   <DynamicSuccessPopup
//         onClose={closePopup}
//         title={!isApprove ? 'Draft Saved Successfully!' : 'Profile Published Successfuly!'}
//         body={!isApprove ? 'Your hospital profile has been saved as a draft. You can edit and submit it for approval anytime.' :'The profile has been approved and published. It is now live and visible to the public.'}
//         closeButtonName="Okay"
//       />
// }
//         </div>

//   )
// }

// export default HospitalProfile
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import { mtCurrencyDto, profileDto } from "../../../../api/Dtos/profileDto";
import { useToaster } from "../../../../Toaster/Toaster";
import { mtCountryDto } from "../../../../api/interfaces/addUser";
import { useLoader } from "../../../../Loader/LoaderContext";
import {
  deleteService,
  getService,
  postService,
} from "../../../../servce/ApisService";
import { API_ENDPOINTS } from "../../../../api";
import DynamicTextPopup from "../../../Portals/Modals/dynamicTextPopup";
import DynamicSuccessPopup from "../../../Portals/Modals/DynamicSuccessPopup";

function HospitalProfile() {
  const [state, mtState] = useState([]);
  const [isOpen, setOpen] = useState(false);
  const router = useNavigate();
  const [isApprove, setIsApprove] = useState(false);
  const [formData, setFormData] = useState<profileDto>();
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState<string[]>([]);
  const [files, setFiles] = useState<(File | null)[]>([]);
  const services = [
    { id: 1, name: "IVF Treatment" },
    { id: 2, name: "IUI Treatment" },
    { id: 3, name: "Surrogacy" },
    { id: 4, name: "Egg/Sperm Freezing Treatment" },
    { id: 5, name: "Fertility Preservation" },
    { id: 6, name: "Fertility Testing" },
  ];
  const treatmentMapping = {
    "IVF Treatment": "IVF_TREATMENT",
    "IUI Treatment": "IUI_TREATMENT",
    Surrogacy: "SURROGACY",
    "Egg/Sperm Freezing Treatment": "SPERM_OR_EGG_FREEZING",
    "Fertility Preservation": "FERTILITY_PRESERVATION",
    "Fertility Testing": "FERTILITY_TESTING",
  } as const; // This ensures that the keys are treated as string literals

  // Function to map the treatment name to the backend value
  const formatTreatmentType = (serviceName: string): string | null => {
    return (
      treatmentMapping[serviceName as keyof typeof treatmentMapping] || null
    );
  };
  const [expanded, setExpanded] = useState<string | false>(false);
  const [expanded1, setExpanded1] = useState<string | false>(false);
  const [events, setEvents] = useState<any[]>([]);
  const [events1, setEvents1] = useState<any[]>([]);
  const [defaultCurrencyId, setDefaultCurrencyId] = useState<number | null>(
    null
  );
  const [mtCurrencyData, setMtCurrency] = useState<mtCurrencyDto[]>([]);
  const { showToast } = useToaster();
  const [isLoading, setIsLoading] = useState(true);
  const [mtContryData, setMtCountry] = useState<mtCountryDto[]>([]);
  const [phoneCode, setPhonecode] = useState({ isoCode: "", code: "" });
  const [selectedCountry, setSelectedCountry] = useState("");
  const [submittedData, setSubmittedData] = useState<profileDto | null>(null);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [file, setFile] = useState<string | null>(null);

  const {
    register,
    handleSubmit,
    control,
    watch,
    setValue,
    reset,
    setError,
    clearErrors,
    trigger,
    formState: { errors, isValid },
  } = useForm<profileDto>({
    defaultValues: {
      name: "",
      email: "",
      phoneNo: "",
      phoneisoCode: "",
      hospitalInfo: "",
      specialization: "",
      size: "",
      street: "",
      apartment: "",
      state: "",
      postalCode: "",
      mtCountryDto: { id: 0, name: "" },
      city: "",
      imageDto: {},
      serviceOfferedDtos: [
        { type: "", cost: "", mtCurrencyDto: { id: 0, name: "" } },
      ],
      leaderShipTeamDtos: [
        {
          id: 0,
          name: "",
          gender: "",
          designation: "",
          bio: "",
          address: "",
          fileDto: {},
        },
      ],
      hospitalCenterReqDtos: [
        {
          id: 0,
          branchAddress: "",
          specialization: "",
          centerSize: "",
          imageDto: {},
          type: "",
          name: "",
        },
      ],
      profileStatus: "",
    },
    mode: "onChange",
  });
  const [isDisabled, setIsDisabled] = useState(true);
  const watchedServices = watch("serviceOfferedDtos");
  const { setLoading } = useLoader();
  useEffect(() => {
    const initializeData = async () => {
      setLoading(true);
      try {
        await mtCountryDtoData();
        await fetchDetails();
        mtStateData();
        await fetchMtCurrencyData();
      } catch (error) {
        console.error("Error during initialization:", error);
      } finally {
        setLoading(false);
      }
    };

    initializeData();
  }, []);
  useEffect(() => {
    const isAnyChecked = services.some((_, index) =>
      Boolean(watch(`serviceOfferedDtos.${index}.type`))
    );
    // 🔥 Force form validation update to refresh button state
    trigger();

    setIsDisabled(!isAnyChecked);
  }, [watch, trigger]);

  const fetchMtCurrencyData = async () => {
    try {
      const response = await getService(API_ENDPOINTS.mtCurrency);
      setMtCurrency(response.data);
      const inrCurrency = response.data.find(
        (currency: mtCurrencyDto) => currency.name === "INR"
      );
      if (inrCurrency) {
        setDefaultCurrencyId(inrCurrency.id);
        services.forEach((_, index) => {
          setValue(
            `serviceOfferedDtos.${index}.mtCurrencyDto.id`,
            inrCurrency.id
          );
        });
      }
    } catch (error) {
      console.error("Error fetching currency data:", error);
    }
  };
  const handleAddEvent = () => {
    const newEventId = events.length + 1;
    setEvents([
      ...events,
      {
        id: newEventId,
        name: `Event ${newEventId}`,
        gender: "",
        designation: "",
        bio: "",
        address: "",

        fileDto: {
          name: "",
          base64Str: "",
          type: "",
          documentUrl: "",
        },
      },
    ]);
    setExpanded(`panel${newEventId}`);
  };
  const handleAddEvents = () => {
    const newEventId = events1.length + 1;
    setEvents1([
      ...events1,
      {
        id: newEventId,
        name: `Event ${newEventId}`,
        startDate: "",
        endDate: "",
        contactPersonName: "",
        contactPersonEmail: "",
        phoneNo: "",
        mtCountryDto: {
          id: null,
          name: "",
          code: "",
          isoCode: "",
        }, // Default mtCountryDto object
        venue: "",
        link: "",
        type: "",
        imageDto: {
          name: "",
          base64Str: "",
          type: "",
          documentUrl: "",
        },
      },
    ]);
    setExpanded1(`panel${newEventId}`);
  };
  const leadId = localStorage.getItem("leadId");
  const fetchDetails = async () => {
    try {
      let url: string;
      const response = await getService(
        API_ENDPOINTS.getProfile + "?leadId=" + leadId
      ); // Fetch post details using 'id'
      setSubmittedData(response.data);
      const res = response.data;
      setEvents(response.data.leaderShipTeamDtos);
      setEvents1(response.data.hospitalCenterReqDtos);
      const countryData = await mtCountryDtoData();
      setSelectedCountry(response.data?.mtCountryDto?.id);
      const selectedIsoCode = response.data?.mtCountryDto?.id;
      const selectedCountry = countryData.find(
        (country: any) => country.id === selectedIsoCode
      );
      if (selectedCountry) {
        setPhonecode({
          isoCode: selectedCountry.isoCode,
          code: selectedCountry.code,
        });
        setValue("phoneisoCode", selectedIsoCode);
      } else {
        const selectedCountry = countryData.find(
          (country: any) => country.id == "1"
        );
        setPhonecode({
          isoCode: selectedCountry.isoCode,
          code: selectedCountry.code,
        });
        setValue("phoneisoCode", selectedIsoCode);
      }
      reset({
        ...response.data, // Resetting other data from the response
        mtCountryDto: response.data?.mtCountryDto?.id || "",
      });
      setTimeout(() => {
        setLoading(false); // Stop loader after 500ms
        setIsLoading(false); // Stop local loading
      }, 500);
    } catch (error) {
      console.error("Error fetching post details:", error);
      setTimeout(() => {
        setLoading(false); // Stop loader in case of error
        setIsLoading(false);
      }, 500);
    }
  };

  const mtCountryDtoData = async () => {
    setLoading(true);
    try {
      const response = await getService(API_ENDPOINTS.countryData);
      setMtCountry(response.data);
      return response.data;
    } catch (error) {
      console.error("Error fetching vehicle data:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 500);
    }
  };

  const handleChange =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setExpanded(isExpanded ? panel : false);
    };
  const handleChanges =
    (panel: string) => (event: React.ChangeEvent<{}>, isExpanded: boolean) => {
      setExpanded1(isExpanded ? panel : false);
    };
  const phoneNuberChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedIsoCode = e.target.value;
    const selectedCountry = mtContryData.find(
      (country: any) => country.isoCode === selectedIsoCode
    );
    if (selectedCountry) {
      setPhonecode({
        isoCode: selectedCountry.isoCode,
        code: selectedCountry.code,
      });
      setValue("phoneisoCode", selectedIsoCode); // Update the selected value for the form
    }
  };
  const handleCountryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedCountryId = e.target.value;
    setSelectedCountry(selectedCountryId);

    const selectedCountry = mtContryData.find(
      (country: any) => country.id == selectedCountryId
    );
    if (selectedCountry) {
      setPhonecode((prev) => {
        const updatedPhoneCode = {
          isoCode: selectedCountry.isoCode,
          code: selectedCountry.code,
        };
        return updatedPhoneCode;
      });
    }
  };
  const handleFileChanges = (
    event: React.ChangeEvent<HTMLInputElement>,
    index: number
  ) => {
    const file = event.target.files?.[0];
    const allowedTypes = ["image/png", "image/jpeg"];
    const maxSizeInMB = 3;

    if (file) {
      // Validate file type
      if (!allowedTypes.includes(file.type)) {
        alert("Please select a valid image (PNG or JPG).");
        return;
      }

      // Validate file size
      if (file.size > maxSizeInMB * 1024 * 1024) {
        alert(`File size should not exceed ${maxSizeInMB} MB.`);
        return;
      }

      // Create a file URL
      const fileUrl = URL.createObjectURL(file);

      // Update the file array
      setFiles((prevFiles) => {
        const updatedFiles = [...prevFiles];
        updatedFiles[index] = file; // Assign the file at the given index
        return updatedFiles;
      });

      // Update the preview URL array
      setSelectedFiles((prevUrls) => {
        const updatedUrls = [...prevUrls];
        updatedUrls[index] = fileUrl; // Assign the URL at the given index
        return updatedUrls;
      });
    }
  };
  const mtStateData = async () => {
    try {
      const respose = await getService(API_ENDPOINTS.matState);
      mtState(respose.data);
    } catch (error) {
      console.error("Error fetching vehicle data:", error);
    } finally {
    }
  };
  const convertFileToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const selectedFile = e.target.files[0];
      setSelectedFile(selectedFile);
      // setValue('imageDto',selectedFile)
      // Convert the file to a Base64 string
      const preview = await convertToBase64(selectedFile);
      setFile(preview);
    }
  };
  const convertToBase64 = (file: File): Promise<string> => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result as string);
      reader.onerror = (error) => reject(error);
    });
  };

  const onFormSubmit: SubmitHandler<profileDto> = async (data) => {
    setFormData(data);
    if (isApprove) {
      const isAnyServiceSelected = data.serviceOfferedDtos.some(
        (service) => service.type
      );
      if (!isAnyServiceSelected) {
        setError("serviceOfferedDtos", {
          type: "manual",
          message: "Please select at least one service.",
        });
        return;
      }
    } else {
      clearErrors();
    }

    setShowConfirmation(true);
  };
  const closePopup = () => {
    setOpen(false);
    router("/vendorDashboard/activateDashbord/HospitalViewProfile/");
  };
  const handleClosePopup = () => setShowConfirmation(false);
  const saveData = async () => {
    setLoading(true);
    try {
      const filteredServices = watchedServices
        .filter((service) => service.type) // Only valid services
        .map((service, index) => ({
          ...service,
          type: formatTreatmentType(services[index].name), // Map the service name
          mtCurrencyDto: {
            id: parseInt(service.mtCurrencyDto.id as unknown as string, 10), // Ensure that the id is parsed as a number
          },
        }));
      const updatedLeaderShipTeamDtos = await Promise.all(
        (formData?.leaderShipTeamDtos ?? []).map(async (team, index) => {
          if (files[index]) {
            const base64Str = await convertFileToBase64(files[index] as File);
            const name = (files[index] as File).name;
            const type = (files[index] as File).type;

            return {
              ...team,
              fileDto: {
                base64Str: base64Str,
                name,
                type,
              },
            };
          }
          return team; // Return unchanged object if no file is uploaded
        })
      );
      let payload = {
        leadId: leadId,
        // ...submittedData,
        name: formData?.name,
        email: formData?.email,
        phoneNo: formData?.phoneNo,
        hospitalInfo: formData?.hospitalInfo,
        specialization: formData?.specialization,
        size: formData?.size,
        imageDto: {
          name: selectedFile?.name,
          type: selectedFile?.type,
          base64Str: file,
        },
        street: formData?.street,
        apartment: formData?.apartment,
        // state:formData?.state,
        postalCode: formData?.postalCode,
        mtCountryDto: formData?.mtCountryDto
          ? {
              id: parseInt(formData?.mtCountryDto as unknown as string, 10),
            }
          : null,
        city: formData?.city,
        serviceOfferedDtos: filteredServices,
        leaderShipTeamDtos: updatedLeaderShipTeamDtos,
        hospitalCenterReqDtos: formData?.hospitalCenterReqDtos.map(
          (center, index) => ({
            ...center,
            id: submittedData?.hospitalCenterReqDtos[index]?.id || null, // Ensure the `id` field is included
          })
        ),
      };
      if (selectedCountry == "1") {
        (payload as any).mtStateDto = {
          id: formData?.state,
        };
      } else {
        (payload as any).state = formData?.state;
      }
      if (isApprove) {
        (payload as any).profilingStatus = "SEND_FOR_APPROVAL";
      }
      const response = await postService(API_ENDPOINTS.saveProfile, payload);
      if (response) {
        setSelectedCountry("");
        setShowConfirmation(false);
        setOpen(true);

        // showToast('Profile has been updated successfully.','success','')
      }
    } catch (error: any) {
      // setApiError(error.response?.data?.message);
      console.error("Login error:", error);
      if (error.response?.data?.message === "Invalid Otp. Please try again.") {
      }
    } finally {
      setLoading(false);
    }
  };
  const back = () => {
    router("/vendorDashboard/activateDashbord/HospitalViewProfile");
  };
  const draft = () => {
    clearErrors();
    setIsApprove(false);
  };
  const approve = () => {
    setIsApprove(true);
  };
  return (
    <div className="mb-5 p-6 ">
      <h3 className="text-gray-900 font-bold text-3xl mb-5 mt-2 flex items-center">
        {" "}
        <span>
          <img
            src="/images/back.svg"
            className="mr-2 cursor-pointer"
            onClick={back}
          />
        </span>
        Hospital Details
      </h3>
      <form onSubmit={handleSubmit(onFormSubmit)}>
        <div className=" rounded-lg mt-5">
          <div className="bg-white p-8">
            <div className=" max-w-[900px] w-full">
              <h3 className="text-gray-900 font-bold text-xl">
                {" "}
                Basic details
              </h3>
              <div className="relative">
                <div className="">
                  <div className="">
                    <div className="flex items-center py-3">
                      <img
                        src={
                          file
                            ? (file as string)
                            : selectedFile
                            ? URL.createObjectURL(selectedFile)
                            : submittedData?.imageDto?.documentUrl ||
                              "/images/userImg.svg"
                        }
                        alt="Preview"
                        className="w-[80px] h-[80px] mr-3 rounded-full"
                      />
                      <div>
                        <p className="font-semibold text-gray-900 text-base font-sans mb-0">
                          Upload Hospital Photo
                          {/* <span className="text-gray-900 font-normal text-sm ml-2">
          (Required)
        </span> */}
                        </p>
                        <p className="text-sm font-normal text-gray-500 mt-1 font-sans mb-3">
                          Photo should be atleast in 150px X 150px
                        </p>
                        <label className=" mt-2 px-4 border border-[#D1D5DB] text-[#374151] font-medium text-sm rounded-md p-2 cursor-pointer">
                          Upload new photo
                          <input
                            type="file"
                            accept="image/*"
                            onChange={handleFileChange}
                            className="hidden"
                          />
                        </label>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 gap-4 mt-2">
                      <div className="form-group">
                        <label
                          htmlFor="username"
                          className="block text-[#374151] font-semibold text-sm font-sans"
                        >
                          Hospital Name{" "}
                          <span className="text-gray-900 font-normal text-sm ml-1">
                            (Required)
                          </span>
                        </label>
                        <div className="input-group mb-3 mt-2">
                          <input
                            {...register("name", {
                              required: isApprove ? "Name is required" : false,
                            })}
                            type="text"
                            placeholder="Enter Hospital Name"
                            className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                          />
                          {errors.name && (
                            <p className="text-primary-color text-sm mt-1">
                              {errors.name.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-7 mb-2 mt-2">
                      <div className="form-group">
                        <label
                          htmlFor="username"
                          className="block text-[#374151] font-semibold text-sm font-sans"
                        >
                          Email
                          <span className="text-gray-900 font-normal text-sm ml-2">
                            (Required)
                          </span>
                        </label>
                        <div className="input-group mb-3 mt-2">
                          <input
                            {...register("email", {
                              required: "Email is required",
                            })}
                            disabled
                            type="email"
                            placeholder="Enter your Email"
                            className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                          />
                          {errors.email && (
                            <p className="text-primary-color text-sm mt-1">
                              {errors.email.message}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="form-group">
                        <label
                          htmlFor="username"
                          className="block text-[#374151] font-semibold text-sm font-sans"
                        >
                          Phone Number
                          {
                            // isApprove &&
                            <span className="text-gray-900 font-normal text-sm ml-2">
                              (Required)
                            </span>
                          }
                        </label>
                        <div className=" form-group mb-4 sm:mb-0">
                          <div className="flex border border-gray-300 rounded mt-1 form-controls mt-2">
                            <select
                              value={phoneCode.isoCode || ""}
                              {...register("phoneisoCode")}
                              onChange={(e) => phoneNuberChange(e)}
                              className="border-none bg-white pl-3 py-2 text-sm font-semibold text-gray-700 focus:outline-none"
                            >
                              {mtContryData.map((item: any) => (
                                <option
                                  key={item.id}
                                  value={item.isoCode || ""}
                                >
                                  {item.isoCode}
                                </option>
                              ))}
                            </select>
                            <input
                              type="text"
                              placeholder="Enter your phone number"
                              {...register("phoneNo", {
                                required: isApprove
                                  ? "Phone Number is required"
                                  : false,
                              })}
                              className="w-full p-2 text-sm text-gray-700 border-gray-300 focus:outline-none"
                            />
                          </div>

                          {errors.phoneNo && (
                            <p className="text-primary-color text-sm mt-1">
                              {errors.phoneNo.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-1 gap-4 mt-2">
                      <div className="form-group">
                        <label
                          htmlFor="username"
                          className="block text-[#374151] font-semibold text-sm"
                        >
                          Hospital Info
                          {
                            // isApprove &&
                            <span className="text-gray-900 font-normal text-sm ml-2">
                              (Required)
                            </span>
                          }
                        </label>
                        <div className="input-group mb-3 mt-2">
                          <textarea
                            rows={4}
                            placeholder="Enter Hospital Info"
                            {...register("hospitalInfo", {
                              required: isApprove
                                ? "Hospital Info is required"
                                : false,
                              maxLength: {
                                value: 1500,
                                message:
                                  "Hospital information cannot exceed 1500 characters. Please shorten your text.",
                              },
                            })}
                            className="w-full border font-normal font-Inter text-sm text-[#6B7280] p-2 rounded-md"
                          />
                          {errors.hospitalInfo && (
                            <p className="text-primary-color text-sm mt-1">
                              {errors.hospitalInfo.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="grid grid-cols-2 gap-5 mb-8">
                      <div className="form-group">
                        <label
                          htmlFor="username"
                          className="block text-[#374151] font-semibold text-sm font-sans"
                        >
                          Specialization{" "}
                          {
                            // isApprove &&
                            <span className="text-gray-900 font-normal text-sm ml-2">
                              (Required)
                            </span>
                          }
                        </label>
                        <div className="input-group mb-3 mt-2">
                          <input
                            {...register("specialization", {
                              required: isApprove
                                ? "specialization is required"
                                : false,
                            })}
                            type="text"
                            placeholder="Enter Specialization"
                            className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                          />
                          {errors.specialization && (
                            <p className="text-primary-color text-sm mt-1">
                              {errors.specialization.message}
                            </p>
                          )}
                        </div>
                      </div>
                      <div className="form-group">
                        <label
                          htmlFor="username"
                          className="mb-1 block text-[#374151] font-semibold text-sm font-sans"
                        >
                          Hospital Size
                          {
                            // isApprove &&
                            <span className="text-gray-900 font-normal text-sm ml-2">
                              (Required)
                            </span>
                          }
                        </label>
                        <div className=" mb-3">
                          <select
                            {...register(`size`, {
                              required: isApprove ? "size is required" : false,
                            })}
                            className={`form-control p-2 rounded mt-1 w-full`}
                          >
                            <option value="">Select Center size</option>
                            <option value="SMALL">Small</option>
                            <option value="MEDIUM">Medium</option>
                            <option value="LARGE">Large</option>
                          </select>
                          {errors.size && (
                            <p className="text-primary-color text-sm mt-1">
                              {errors.size.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                    <p className="border-b-2 border-gray-200"></p>
                    <div className="mt-8">
                      <h2 className="text-gray-900 font-bold text-[20px]">
                        Address
                        <span className="text-gray-900 font-normal text-sm ml-2">
                          (Required)
                        </span>
                      </h2>
                      <div className="grid grid-cols-1 gap-4 mt-2">
                        <div className="form-group">
                          <label
                            htmlFor="username"
                            className="block text-[#374151] font-semibold text-sm font-Inter"
                          >
                            Street Address
                          </label>
                          <div className="input-group mb-3 mt-2">
                            <input
                              {...register("street", {
                                required: isApprove
                                  ? " Street Address  is required"
                                  : false,
                              })}
                              type="text"
                              placeholder="eg. Street 7"
                              className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                            />
                            {errors.street && (
                              <p className="text-primary-color text-sm mt-1">
                                {errors.street.message}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-1 gap-4 mt-2">
                        <div className="form-group">
                          <label
                            htmlFor="username"
                            className="block text-[#374151] font-semibold text-sm"
                          >
                            Location
                          </label>
                          <div className="input-group mb-3 mt-2">
                            <input
                              {...register("apartment", {
                                required: isApprove
                                  ? "Location is required"
                                  : false,
                              })}
                              type="text"
                              placeholder="Enter Location"
                              className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                            />
                            {errors.apartment && (
                              <p className="text-primary-color text-sm mt-1">
                                {errors.apartment.message}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-5 mt-2">
                        <div className="form-group">
                          <label
                            htmlFor="username"
                            className="block text-[#374151] font-semibold text-sm"
                          >
                            Country
                          </label>
                          <div className="input-group mb-3 mt-2">
                            <select
                              value={selectedCountry || ""}
                              {...register("mtCountryDto", {
                                required: isApprove
                                  ? "Country is required"
                                  : false,
                              })}
                              onChange={(e) => handleCountryChange(e)}
                              className={`border p-2 rounded-md mt-1 w-full`}
                            >
                              <option value="">Select country</option>
                              {mtContryData.map((item: any) => (
                                <option
                                  key={item.id}
                                  value={item.id !== null ? item.id : ""}
                                >
                                  {item.name}
                                </option>
                              ))}
                            </select>
                            {errors.mtCountryDto && (
                              <p className="text-primary-color text-sm mt-1">
                                {errors.mtCountryDto.message}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="form-group">
                          <label
                            htmlFor="username"
                            className="block text-[#374151] font-semibold text-sm"
                          >
                            State
                          </label>
                          <div className="input-group mb-3 mt-2">
                            {selectedCountry == "1" ? (
                              <select
                                {...register("state")}
                                className={`form-control p-2 rounded mt-1 w-full ${
                                  errors.state
                                    ? "border-[#B91C1C] border-2"
                                    : "border-gray-300 border"
                                }`}
                              >
                                <option value="">Select State</option>
                                {state.map((item: any) => (
                                  <option
                                    key={item.id}
                                    value={item.id !== null ? item.id : ""}
                                  >
                                    {item.name}
                                  </option>
                                ))}
                              </select>
                            ) : (
                              <input
                                {...register("state", {
                                  required: isApprove
                                    ? "State is required"
                                    : false,
                                })}
                                type="text"
                                placeholder="Enter state"
                                className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                              />
                            )}
                            {errors.state && (
                              <p className="text-primary-color text-sm mt-1">
                                {errors.state.message}
                              </p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="grid grid-cols-2 gap-5 mt-2">
                        <div className="form-group">
                          <label
                            htmlFor="username"
                            className="block text-[#374151] font-semibold text-sm"
                          >
                            City
                          </label>
                          <div className="input-group mb-3 mt-2">
                            <input
                              {...register("city", {
                                required: isApprove
                                  ? "City is required"
                                  : false,
                              })}
                              type="text"
                              placeholder="Enter City Name"
                              className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                            />
                            {errors.city && (
                              <p className="text-primary-color text-sm mt-1">
                                {errors.city.message}
                              </p>
                            )}
                          </div>
                        </div>
                        <div className="form-group">
                          <label
                            htmlFor="username"
                            className="block text-[#374151] font-semibold text-sm"
                          >
                            Postal Code
                          </label>
                          <div className="input-group mb-3 mt-2">
                            <input
                              onInput={(e: any) =>
                                (e.target.value = e.target.value.replace(
                                  /\D/g,
                                  ""
                                ))
                              }
                              {...register("postalCode", {
                                required: isApprove
                                  ? "Postal Code is required"
                                  : false,
                              })}
                              type="text"
                              placeholder="Enter Postal Code"
                              className="form-control font-normal font-Inter text-sm text-[#6B7280] w-full p-2 rounded-md"
                            />
                            {errors.postalCode && (
                              <p className="text-primary-color text-sm mt-1">
                                {errors.postalCode.message}
                              </p>
                            )}
                          </div>
                        </div>
                        {/* Fixed Navigation Buttons */}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-white p-4 md:p-6 lg:p-8 mt-4 md:mt-7 rounded-lg shadow-sm">
            <div className=" max-w-[900px] w-full">
              <h2 className="text-gray-900 font-bold text-lg md:text-xl pb-4 md:pb-5 flex items-center flex-wrap">
                Services Offered
                <span className="text-gray-900 font-normal text-xs md:text-sm ml-2">
                  (Required)
                </span>
              </h2>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                {services.map((service, index) => {
                  const isChecked = Boolean(
                    watch(`serviceOfferedDtos.${index}.type`)
                  );

                  return (
                    <div
                      key={service.id}
                      className="border border-gray-200 rounded-lg p-4 md:p-6 flex flex-col items-start"
                    >
                      {/* Checkbox and Service Name */}
                      <label className="flex items-center mb-4 md:mb-5 font-bold text-sm md:text-base font-sans text-gray-900 w-full">
                        <input
                          type="checkbox"
                          {...register(`serviceOfferedDtos.${index}.type`)}
                          value="true"
                          className="mr-3 md:mr-4 w-4 h-4 form-checkbox accent-[#B00A2B] focus:accent-[#B00A2B]"
                        />
                        <span className="break-words">{service.name}</span>
                      </label>

                      {/* Cost and Currency Fields */}
                      <p className="font-semibold font-Inter text-sm text-gray-700 pb-2 w-full">
                        Approximate Cost
                      </p>
                      <div className="w-full flex flex-col md:flex-row gap-2 md:space-x-2">
                        {/* Currency Field */}
                        <div className="w-full md:w-1/3">
                          <Controller
                            control={control}
                            name={`serviceOfferedDtos.${index}.mtCurrencyDto.id`}
                            render={({ field }) => (
                              <select
                                {...field}
                                value={field.value ?? ""}
                                disabled={!isChecked}
                                className={`w-full bg-white h-full  py-2 px-2 text-xs font-semibold text-gray-700 border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-gray-400 ${
                                  !isChecked
                                    ? "bg-gray-100 cursor-not-allowed"
                                    : ""
                                }`}
                              >
                                <option value="">Select</option>
                                {mtCurrencyData.map((item) => (
                                  <option key={item.id} value={item.id ?? ""}>
                                    {item.name}
                                  </option>
                                ))}
                              </select>
                            )}
                          />
                          {errors?.serviceOfferedDtos?.[index]?.mtCurrencyDto
                            ?.id && (
                            <p className="text-primary-color text-xs mt-1">
                              {
                                errors?.serviceOfferedDtos[index]?.mtCurrencyDto
                                  ?.id?.message
                              }
                            </p>
                          )}
                        </div>

                        {/* Cost Field */}
                        <div className="w-full md:w-2/3">
                          <input
                            type="number"
                            {...register(`serviceOfferedDtos.${index}.cost`, {
                              valueAsNumber: true,
                              setValueAs: (value) => (value === "" ? 0 : value),
                            })}
                            disabled={!isChecked}
                            placeholder="Enter Approximate Cost"
                            className={`w-full border border-gray-300 rounded p-2 font-normal text-sm md:text-base ${
                              !isChecked ? "bg-gray-100 cursor-not-allowed" : ""
                            }`}
                          />
                          {errors?.serviceOfferedDtos?.[index]?.cost && (
                            <p className="text-primary-color text-xs mt-1">
                              {errors?.serviceOfferedDtos[index]?.cost?.message}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>

              {errors.serviceOfferedDtos && (
                <p className="text-primary-color text-sm mt-2">
                  {errors.serviceOfferedDtos.message}
                </p>
              )}
            </div>
          </div>
          <div className="bg-white p-8 mt-7">
            <div className=" max-w-[900px] w-full">
              <p className="text-gray-900 font-bold text-[20px] font-Inter">
                Leadership Team
                {/* <span className='text-gray-900 font-normal text-base'>(Optional)</span> */}
                <span className="text-gray-900 font-normal text-base ml-2">
                  (Optional)
                </span>
              </p>
              {/* <form onSubmit={handleSubmit(onFormSubmit)}> */}
              <div className="form-group mb-10 mt-5">
                {events.map((event: any, index: number) => (
                  <div className="mt-4">
                    <div className="mb-3 bg-gray-100" key={event.id}>
                      <Accordion
                        key={event?.id}
                        expanded={expanded === `panel${event?.id}`}
                        onChange={handleChange(`panel${event?.id}`)}
                        className="accordion-root"
                        style={{ boxShadow: "none" }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls={`panel${event?.id}-content`}
                          id={`panel${event?.id}-header`}
                          className="accordion-summary text-lg font-semibold"
                          style={{ backgroundColor: "#f3f4f6" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              className="text-lg font-semibold"
                              style={{ fontWeight: "600", fontSize: "18px" }}
                            >
                              {submittedData?.leaderShipTeamDtos?.[
                                index
                              ]?.name?.trim()
                                ? submittedData.leaderShipTeamDtos[index].name
                                : `User ${index + 1}`}
                              {/* User {index +1} */}
                            </Typography>
                            {/* <img src='/images/deleteIcon.svg' className='mr-2' onClick={(e:any)=>
                 { e.stopPropagation();
                    deleteFun(event,'leaderShip')}} /> */}
                          </div>
                        </AccordionSummary>
                        <AccordionDetails className="accordion-details bg-gray-100 p-4">
                          <Typography component={"div"}>
                            {/* Profile Photo Upload */}
                            <div className="flex flex-col md:flex-row md:items-center py-3">
                              <img
                                src={
                                  files[index] && files[index] instanceof Blob
                                    ? URL.createObjectURL(files[index] as Blob)
                                    : submittedData?.leaderShipTeamDtos[index]
                                        ?.fileDto?.documentUrl ||
                                      "/images/userImg.svg"
                                }
                                alt="Preview"
                                className="w-[80px] h-[80px] mb-3 md:mb-0 md:mr-4 rounded-full object-cover"
                              />
                              <div>
                                <p className="font-semibold text-gray-900 text-sm md:text-base font-sans">
                                  Upload Hospital Photo
                                </p>
                                <p className="text-xs md:text-sm font-normal text-gray-500 mt-1 md:mt-2 font-sans mb-3">
                                  Photo should be atleast in 150px X 150px
                                </p>

                                <label className="px-4 py-2 border border-[#D1D5DB] text-[#374151] font-medium text-xs md:text-sm rounded-md cursor-pointer inline-block hover:bg-gray-50">
                                  Upload new photo
                                  <input
                                    type="file"
                                    accept="image/*"
                                    onChange={(e) =>
                                      handleFileChanges(e, index)
                                    }
                                    className="hidden"
                                  />
                                </label>
                              </div>
                            </div>

                            {/* Name Field */}
                            <div className="form-group mb-4">
                              <label className="block mb-1 ml-1 font-semibold text-gray-700 text-sm font-Inter">
                                Name
                              </label>
                              <div className="relative">
                                <input
                                  type="text"
                                  placeholder="Enter Name"
                                  {...register(
                                    `leaderShipTeamDtos.${index}.name`
                                  )}
                                  className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500"
                                />
                                {errors?.leaderShipTeamDtos?.[index]?.name && (
                                  <p className="text-primary-color text-xs mt-1">
                                    {
                                      errors?.leaderShipTeamDtos?.[index]?.name
                                        ?.message
                                    }
                                  </p>
                                )}
                              </div>
                            </div>

                            {/* Gender and Designation */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 lg:gap-20">
                              <div className="form-group mb-4">
                                <label className="block mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                  Gender
                                </label>
                                <div className="relative">
                                  <select
                                    {...register(
                                      `leaderShipTeamDtos.${index}.gender`
                                    )}
                                    className="w-full border border-gray-300 mt-1 px-3 py-2 rounded-md text-sm text-[#111827] focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500"
                                  >
                                    <option value="">Select Gender</option>
                                    <option value="MALE">Male</option>
                                    <option value="FEMALE">Female</option>
                                    <option value="OTHERS">Others</option>
                                  </select>
                                </div>
                              </div>

                              <div className="form-group mb-4">
                                <label className="block mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                  Designation
                                </label>
                                <div className="relative">
                                  <input
                                    type="text"
                                    placeholder="Enter Designation"
                                    {...register(
                                      `leaderShipTeamDtos.${index}.designation`
                                    )}
                                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500"
                                  />
                                </div>
                              </div>
                            </div>

                            {/* Bio */}
                            <div className="form-group mb-4">
                              <label className="block mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                Bio
                              </label>
                              <div className="relative">
                                <textarea
                                  rows={4}
                                  placeholder="Enter Bio"
                                  {...register(
                                    `leaderShipTeamDtos.${index}.bio`,
                                    {
                                      maxLength: {
                                        value: 500,
                                        message:
                                          "Bio must be at most 500 characters",
                                      },
                                    }
                                  )}
                                  className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500"
                                />
                                {errors?.leaderShipTeamDtos?.[index]?.bio && (
                                  <p className="text-primary-color text-xs mt-1">
                                    {
                                      errors?.leaderShipTeamDtos[index]?.bio
                                        ?.message
                                    }
                                  </p>
                                )}
                              </div>
                            </div>

                            {/* Address */}
                            <div className="form-group mb-4">
                              <label className="block mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                Address
                              </label>
                              <div className="relative">
                                <textarea
                                  rows={4}
                                  placeholder="Enter Address"
                                  {...register(
                                    `leaderShipTeamDtos.${index}.address`
                                  )}
                                  className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500"
                                />
                              </div>
                            </div>
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    </div>
                  </div>
                ))}
                <div
                  onClick={handleAddEvent}
                  className="mt-4 p-2 w-[11.5rem] h-10 cursor-pointer bg-[#FFFFFF] text-gray-700 rounded border border-gray-300"
                >
                  {events.length === 0
                    ? "+ Add User Details"
                    : "+ Add another user"}
                </div>
                {/* )} */}
              </div>

              {/* </form> */}
            </div>
          </div>
          <div className="bg-white p-8 mt-7">
            <div className=" max-w-[900px] w-full">
              <p className="text-gray-900 font-bold text-[20px]">
                Add center details
                <span className="text-gray-900 font-normal text-base ml-2">
                  (Optional)
                </span>
              </p>
              {/* <form onSubmit={handleSubmit(onFormSubmit)}> */}
              <div className="form-group mb-10 mt-5">
                {events1.map((event: any, index: number) => (
                  <div className="mt-4">
                    {/* <> */}

                    <div className="mb-3 bg-gray-100" key={event.id}>
                      <Accordion
                        key={event?.id}
                        expanded={expanded1 === `panel${event?.id}`}
                        onChange={handleChanges(`panel${event?.id}`)}
                        className="accordion-root"
                        style={{ boxShadow: "none" }}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          aria-controls={`panel${event?.id}-content`}
                          id={`panel${event?.id}-header`}
                          className="accordion-summary text-lg font-semibold"
                          style={{ backgroundColor: "#f3f4f6" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              alignItems: "center",
                              width: "100%",
                              justifyContent: "space-between",
                            }}
                          >
                            <Typography
                              className="text-lg font-semibold"
                              style={{ fontWeight: "600", fontSize: "18px" }}
                            >
                              {submittedData?.hospitalCenterReqDtos?.[
                                index
                              ]?.name?.trim()
                                ? submittedData.hospitalCenterReqDtos[index]
                                    .name
                                : `Center ${index + 1}`}
                              {/* Center {index +1} */}
                            </Typography>
                            {/* <img src='/images/deleteIcon.svg' className='mr-2' onClick={(e:any)=>
                 { e.stopPropagation();
                    deleteFun(event,'centers')}} /> */}
                          </div>
                        </AccordionSummary>
                        <AccordionDetails className="accordion-details bg-gray-100 p-4">
                          <Typography component={"div"}>
                            {/* Center Name */}
                            <div className="form-group mb-4">
                              <label className="block mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                Center Name
                              </label>
                              <div className="relative">
                                <input
                                  type="text"
                                  placeholder="Enter Center Name"
                                  {...register(
                                    `hospitalCenterReqDtos.${index}.name`
                                  )}
                                  className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500"
                                />
                              </div>
                            </div>

                            {/* Specialization and Center Size */}
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 lg:gap-16">
                              <div className="form-group mb-4">
                                <label className="block mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                  Specialization
                                </label>
                                <div className="relative">
                                  <input
                                    type="text"
                                    placeholder="Enter Specialization"
                                    {...register(
                                      `hospitalCenterReqDtos.${index}.specialization`
                                    )}
                                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500"
                                  />
                                </div>
                              </div>

                              <div className="form-group mb-4">
                                <label className="block mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                  Center Size
                                </label>
                                <div className="relative">
                                  <select
                                    className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500"
                                    {...register(
                                      `hospitalCenterReqDtos.${index}.centerSize`
                                    )}
                                  >
                                    <option value="">Select Center size</option>
                                    <option value="SMALL">Small</option>
                                    <option value="MEDIUM">Medium</option>
                                    <option value="LARGE">Large</option>
                                  </select>
                                </div>
                              </div>
                            </div>

                            {/* Address */}
                            <div className="form-group mb-4">
                              <label className="block mb-1 ml-1 font-semibold text-gray-700 text-sm">
                                Address
                              </label>
                              <div className="relative">
                                <textarea
                                  rows={4}
                                  placeholder="Enter Address"
                                  {...register(
                                    `hospitalCenterReqDtos.${index}.branchAddress`
                                  )}
                                  className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:border-gray-500 focus:ring-1 focus:ring-gray-500"
                                />
                              </div>
                            </div>
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    </div>

                    {/* </> */}
                  </div>
                ))}

                <div
                  onClick={handleAddEvents}
                  className="mt-4 p-2 w-[11.5rem] h-10 cursor-pointer bg-[#FFFFFF] text-gray-700 rounded border border-gray-300"
                >
                  {events1.length === 0
                    ? "+ Add Center Details"
                    : "+ Add another center"}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="px-4 flex justify-end  p-4 items-center  bg-white"
          style={{
            boxShadow: "0px -16px 50px 0px #0000000D",
          }}
        >
          <div>
            <button
              type="submit"
              className="border border-gray-300 px-4 py-2 rounded-md text-sm text-gray-700 mr-2"
              onClick={draft}
              // disabled={!isValid}
            >
              Save as draft
            </button>
          </div>
          <div>
            <button
              type="submit"
              className="px-7 py-2 gradient-background font-Inter text-white rounded font-bold text-base"
              onClick={approve}
              // disabled={ isDisabled}
            >
              Approve & Publish Profile
            </button>
          </div>
        </div>
      </form>
      {showConfirmation && (
        <DynamicTextPopup
          onClose={handleClosePopup}
          title={
            isApprove ? "Confirm Approval & Publish " : "Confirm Save as draft"
          }
          body={
            isApprove
              ? "Are you sure you want to approve and publish this profile? Once published, the profile will be visible to the public. "
              : " Your hospital profile details will be saved as a draft. You can edit and submit for approval later."
          }
          confirmButtonName={
            isApprove ? "Approve & Publish" : "Yes, Save as Draft"
          }
          closeButtonName="Cancel"
          onConfirm={saveData}
        />
      )}
      {isOpen && (
        <DynamicSuccessPopup
          onClose={closePopup}
          title={
            !isApprove
              ? "Draft Saved Successfully!"
              : "Profile Submitted for Approval!"
          }
          body={
            isApprove
              ? "Your hospital profile has been successfully submitted for approval. Our team will review the details, and you will be notified once it's approved."
              : "Your hospital profile has been saved as a draft. You can edit and submit it for approval anytime."
          }
          closeButtonName="Okay"
        />
      )}
    </div>
  );
}

export default HospitalProfile;
